import { Component ,ElementRef} from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
declare var $:any;

@Component({
  selector: 'app-app-version',
  templateUrl: './app-version.component.html',
  styleUrls: ['./app-version.component.scss']
})
export class AppVersionComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public currentdetail:any='';

  staticData = new FormGroup({
    version:new FormControl(''),
    version1:new FormControl(''),
  })
  
   get f() { return this.staticData.controls; }

  constructor(private el: ElementRef,public router: Router, public service: GlobalService) {   
    this.getDetail(); 
  }

  ngOnInit(): void {
  }

  getDetail(){      
    this.service.GetApi('/get-version').subscribe(((response:any)=>{
      if(response.success ==1) {  
        var self =this,kk:any=[];  
        this.loading=false;
        response.data.filter((el:any)=>{
          if(el.device !='Browser'){
            kk.push(el);
          }
        })
        this.currentdetail=kk;
      } else {
        this.loading=false;
      }
    }), (error) => { this.loading =false; });
  }

  Onsubmit(id:any,type:any){
    this.submitted = true;    
      let userdetail = this.staticData;
      if(userdetail.valid){
        this.loading=true;
        var url="update-version/"+id;
        var detail:any={        };
        if(type==1){
          this.staticData.controls["version"].setValidators([Validators.required]);
          this.staticData.controls["version"].updateValueAndValidity();
          detail.version=userdetail.value.version;
        } else {
          this.staticData.controls["version1"].setValidators([Validators.required]);
          this.staticData.controls["version1"].updateValueAndValidity();
          detail.version=userdetail.value.version1;
        }
        this.service.updateApi1(detail,url).subscribe(((response:any)=>{
          if(response.success ==1){ 
            this.service.successAlert(response.message) ;       
            this.submitted = false;  
            this.loading=false; 
            this.getDetail();
          } else {
            this.service.dangerAlert(response.message);
            this.loading=false;
          }
        }), (error:any) => {
          this.loading=false;
        });
      } else{
        this.loading = false
        userdetail.markAllAsTouched();
        this.scrollToFirstInvalidControl();  
      }
  }
  
  private scrollToFirstInvalidControl() {
    const firstInvalidControl: HTMLElement = this.el.nativeElement.querySelector(
      "form .ng-invalid"
    );
    // firstInvalidControl.focus(); //without smooth behavior
    window.scroll({
      top: this.getTopOffset(firstInvalidControl),
      left: 0,
      behavior: "smooth"
    });
  }
  
  private getTopOffset(controlEl: HTMLElement): number {
    const labelOffset = 50;
    return controlEl.getBoundingClientRect().top + window.scrollY - labelOffset;
  }


}
